import { render, staticRenderFns } from "./FAQGroupDeleteConfirm.vue?vue&type=template&id=966e50fa&"
import script from "./FAQGroupDeleteConfirm.vue?vue&type=script&lang=js&"
export * from "./FAQGroupDeleteConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports